/*eslint-env jquery*/
import React, { Component, useState } from 'react'
import { Link } from 'react-router-dom'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import Select from 'react-select'
import { unitProductOperationsService } from '../../_services/unitProductOperations.service'
import DatePicker from '../Shared/DatePicker'
import { DecimalInput } from 'react-hichestan-numberinput'
// import { GoPlusSmall } from 'react-icons/go'
import { FaInfoCircle } from 'react-icons/fa'
import TaskCode from '../Shared/TaskCode'
// import { FiTrash2, FiPlus } from 'react-icons/fi'
// import config from '../../config'
// import NumberFormat from 'react-number-format'
// import ImportExcel from './ImportExcel'
// import { Tabs, Tab } from 'react-bootstrap'
import ProductOperationForm from './ProductOperationForm'
import ProductOperationDetails from './ProductOperationDetails'
import { GiMagnifyingGlass } from 'react-icons/gi'
import { MdPlaylistAddCheck, MdAdd, MdRemove } from 'react-icons/md'
import { AsyncWarehouseSelect } from '../Shared/AsyncWarehouseSelect'
// import ConvertQuantity from '../Shared/ConvertQuantity'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'

import { Input } from 'antd'
import { Field, FastField, ErrorMessage, getIn, Formik } from 'formik'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
// import measurementTypes from '../../_constants/measurementTypes'
import { AsyncCategorySelect } from '../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../Shared/AsyncBrandSelect'
import moment from 'moment-jalaali'
import MeasurementTypeDoubleBox from '../Shared/MeasurementTypeDoubleBox'
import { connect } from 'react-redux'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const requestData = (pageSize, page, sorted, filtered, dto) => {
  // // console.log(dto)
  return new Promise(async (resolve, reject) => {
    // var dto = {};
    dto['pageSize'] = pageSize
    dto['page'] = page
    if (sorted && sorted.length > 0) {
      dto['sorted'] = sorted[0]
    }

    console.log(JSON.stringify(dto))

    var result = []
    await unitProductOperationsService
      .getAllPaginate(JSON.stringify(dto))
      .then(res => {
        console.log(res)
        result = res.data
      })
      .catch(err => {
        // setTimeout(() => requestData(pageSize, page, sorted, filtered, dto), 5000);
        // // console.log(err);
      })

    setTimeout(() => resolve(result), 100)
  })
}

class ProductOperationsList extends Component {
  constructor(props, context) {
    super(props, context)

    var pageSize = parseInt(localStorage.getItem('pageSize'), 0)
    this.state = {
      initialItems: [],
      data: [],
      loading: false,
      confirmDeleteShow: false,
      requiredItem: 0,
      deleteItemIndex: 0,
      model: {},
      resetUpload: false,
      unitId: undefined,
      unitProductOperationType: this.props.unitProductOperationType,

      searchModal: false,
      pageSize: pageSize ? pageSize : 10,
      dto: {
        page: 0,
        pageSize: pageSize,
        unitProductOperationType: this.props.unitProductOperationType,
        sorted: { id: 'createdAt', desc: true }
      },
      totalRecords: 0
    }
  }

  fetchData = (state, instance) => {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true })
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered,
      this.state.dto
    )
      .then(res => {
        // // console.log(res);

        if (res.data) {
          // var pageSize = res.data.result.length > state.pageSize ? state.pageSize : res.data.result.length;
          // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
          this.setState({
            data: res.data,
            // pages: res.totalPage,
            pages: Math.ceil(res.totalRecords / state.pageSize),
            totalRecords: res.totalRecords,
            loading: false,
            modal: false,
            searchModal: false,
            pageSize: state.pageSize
          })
        }
      })
      .catch(err => {
        // console.log(err);

        this.setState({ loading: false, searchModal: false })
      })
  }

  _handleSearch = e => {
    let searcjQery = e.target.value.toLowerCase(),
      displayedItems = this.state.initialItems.filter(el => {
        let searchValue = el.name.toLowerCase()
        return searchValue.indexOf(searcjQery) !== -1
      })
    this.setState({
      data: displayedItems
    })
  }

  _handleCancelSearch = e => {
    document.getElementById('searchInput').value = ''
    this.setState({
      data: this.state.initialItems
    })
  }

  handleFilterChange = () => {
    const current = this.reactTable.getResolvedState()

    if (current) {
      const recordsCount = current.sortedData.length
      this.setState({ recordsCount })
      // return false
      // console.log(recordsCount);
    }
  }

  handleSearch = values => {
    // console.log(values);

    this.setState({ loading: true })

    if (values) {
      // // Object.keys(values).length > 0 &&
      //   Object.entries(values)
      //     .reduce((acc, [key, value]) => {
      //       dto[key] = value
      //     })
      this.setState({ dto: values, page: 0 }, () => {
        // console.log(dto);
        this.table.fireFetchData()
      })
    }
  }

  handleShowAll = () => {
    var dto = {
      sorted: { id: 'createdAt', desc: true },
      unitId: this.state.unitId
    }
    this.setState({ dto: dto }, () => {
      this.table.fireFetchData()
    })
  }

  // componentDidMount() {

  //   this.getData()

  // }

  handleModalOperation = type => {
    this.setState({ unitProductOperationType: type }, () => {
      this.setState({
        modalHeading: 'عملیات ورود و خروج کالا',
        modal: true,
        model: { name: '', measurementType: '', image: '' }
      })
    })
  }

  handleModalEdit = e => {
    let _model = this.state.data[e]
    this.setState({
      modal: true,
      model: _model,
      modalHeading: 'ویرایش کالای "' + _model.name + '"'
    })
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false })
  }

  handleDetailsModalShow = _model => {
    this.setState({ detailsModal: true, model: _model })
  }
  handleDetailsModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ detailsModal: false })
  }

  handleModalClose = () => {
    this.setState({ modal: false }, () => {
      this.table.fireFetchData()
    })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  getData() {
    this.setState({ loading: true })
    unitProductOperationsService
      .getAllByCategoryType(this.props.categoryType)
      .then(res => {
        console.log(res.data)
        this.setState({
          initialItems: res.data,
          data: res.data,
          loading: false
        })
      })
      .catch(error => {
        // console.log(error);
        this.setState({ loading: false })
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = e => {
    let _model = this.state.data[e]

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })
    // console.log(this.state.model);
    unitProductOperationsService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف کالا ', 'کالا با موفقیت حذف شد')
        this.table.fireFetchData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  importFromExcel = values => {
    this.setState({ loading: true })

    values.splice(0, 1)
    var dto = []

    values.forEach(product => {
      var obj = {}

      if (product[0] && product[2]) {
        obj['extraCode'] = parseInt(product[0], 0)
        obj['quantity'] = parseInt(product[2], 0)

        dto.push(obj)
      }
    })

    // console.log(JSON.stringify(dto));

    unitProductOperationsService
      .importFromExcel(JSON.stringify(dto))
      .then(res => {
        var updatedCount = res.data
        toastr.success('موجودی ' + updatedCount + ' کالا بروزرسانی شد')
        this.getData()
      })
      .catch(error => {
        // console.log(error);
        this.setState({ loading: false })
      })
  }

  handleUnitIdChange = (unitId, categoryType) => {
    let dto = this.state.dto
    dto['unitId'] = unitId

    this.setState(
      { dto: dto, unitId: unitId, categoryType: categoryType },
      () => {
        this.table.fireFetchData()
      }
    )
  }

  render() {
    const { user } = this.props;
    const {
      pageSize,
      data,
      pages,
      loading,
      searchModal,
      dto,
      categoryType
    } = this.state
    return (
      <div>
        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            manual
            data={data}
            pages={pages}
            loading={loading}
            onFetchData={this.fetchData}
            ref={instance => {
              this.table = instance
            }}
            sorted={this.state.sorted}
            onSortedChange={(newSort, column) => {
              this.setState({ sorted: newSort })
            }}
            onPageSizeChange={pageSize => {
              // const { dispatch } = this.props;
              // dispatch( setPageSize(pageSize) )
              localStorage.setItem('pageSizeForProjects', pageSize)
              // this.setState({ page: 0 });
            }}
            page={this.state.page}
            onPageChange={page => this.setState({ page })}
            defaultPageSize={pageSize}
            previousText="صفحه قبل"
            nextText="صفحه بعد"
            loadingText="در حال بارگذاری ..."
            noDataText="نتیجه ای یافت نشد"
            pageText="صفحه"
            ofText="از"
            rowsText="تعداد نمایش"
            // renderPageSizeOptions = ({ pageSize, pageSizeOptions, rowsSelectorText, onPageSizeChange, rowsText }) => { return (<select onChange={e => onPageSizeChange(Number(e.target.value))} value={pageSize} > {pageSizeOptions.map((option, i) => ( // eslint-disable-next-line react/no-array-index-key <option key={i} value={option}> {${option} ${{this.props.rowsText}}} </option> ))} </select>) }

            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value
            }
            getTableProps={() => ({ style: { display: 'block' } })}
            getTrProps={(state, rowInfo, column, instance) => {
              const newSelected = Object.assign({}, this.state.selected)
              const selected = rowInfo
                ? newSelected[rowInfo.original.id]
                : false
              return {
                style: {
                  backgroundColor: selected && '#5079F7',
                  color: selected && 'white'
                }
              }
            }}
            columns={[
              {
                Header: 'ردیف',
                id: 'id',
                maxWidth: 50,
                filterable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                Cell: row => {
                  return row.page * row.pageSize + (row.index + 1)
                }
              },
              // {
              //   Header: 'عکس کالا',
              //   accessor: 'photoName',
              //   id: "photoName",
              //   width: 100,
              //   sortable: false,
              //   filterable: false,
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   Cell: row => (
              //     row.original.images && row.original.images.length > 0 ?
              //       <img style={{ height: 70, width: 80, display: 'inline' }} alt='' src={config.uploadsUrl + row.original.images[0]} />
              //       : ''
              //   ),
              // },
              {
                Header: 'دسته بندی',
                accessor: 'category',
                id: 'category',
                width: 150,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center',
                  direction: 'ltr'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['category.id'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ filter, onChange }) => (
                  // <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
                  <AsyncCategorySelect
                    clearable
                    categoryType={this.props.categoryType}
                    onChange={val => {
                      onChange(val)
                    }}
                  />
                ),
                Cell: row => row.original.unitProduct.product.category.name
              },
              {
                Header: 'برند',
                accessor: 'brand',
                id: 'brand',
                width: 150,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center',
                  direction: 'ltr'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['brand.id'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ filter, onChange }) => (
                  <AsyncBrandSelect
                    clearable
                    brandType={this.props.categoryType === 0 ? 0 : 1}
                    onChange={val => {
                      onChange(val)
                    }}
                  />
                ),

                Cell: row => row.original.unitProduct.product.brand.name
              },
              {
                Header: 'کد کالا',
                accessor: 'extraCode',
                id: 'extraCode',
                width: 120,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['extraCode'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ filter, onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: row =>
                  row.original.unitProduct.product.extraCode
                    ? row.original.unitProduct.product.extraCode
                    : '-'
              },
              {
                Header: 'کد کوتاه کالا',
                accessor: 'shortExtraCode',
                id: 'shortExtraCode',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                width: 100,
                Cell: row =>
                  row.original.unitProduct.product.shortExtraCode
                    ? row.original.unitProduct.product.shortExtraCode
                    : '-'
              },
              {
                Header: 'نام کالا',
                accessor: 'name',
                id: 'name',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['name'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ filter, onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: row =>
                  row.original.unitProduct.product.name
                    ? row.original.unitProduct.product.name
                    : '-'
              },
              // {
              //   Header: "موجودی قبلی",
              //   id: "quantity",
              //   accessor: d => d.quantity,
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   className: "numberFa",
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["quantity"], threshold: matchSorter.rankings.CONTAINS }),
              //   filterAll: true,
              //   Filter: ({ filter, onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
              //   Cell: row => (
              //     row.original.previousQuantity !== undefined
              //     ? <MeasurementTypeDoubleBox
              //       product={row.original.unitProduct.product}
              //       value={row.original.previousQuantity}
              //     />
              //     : ''
              //   )

              // },
              {
                Header: 'مقدار ورود / خروج',
                id: 'quantity',
                accessor: d => d.quantity,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                width: 180,
                Cell: row =>
                  row.original.quantity !== undefined ? (
                    <MeasurementTypeDoubleBox
                      product={row.original.unitProduct.product}
                      value={row.original.quantity}
                      sign={
                        row.original.unitProductOperationType == 0 ? '+' : '-'
                      }
                    />
                  ) : (
                    ''
                  )
              },
              {
                Header: 'موجودی',
                id: 'nextQuantity',
                accessor: d => d.quantity,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                width: 180,
                Cell: row =>
                  row.original.nextQuantity !== undefined ? (
                    <MeasurementTypeDoubleBox
                      product={row.original.unitProduct.product}
                      value={row.original.nextQuantity}
                    />
                  ) : (
                    0
                  )
              },
              // {
              //   Header: "واحد اصلی",
              //   id: "measurementType",
              //   accessor: d => d.measurementType,
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   className: "numberFa",
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["measurementType"], threshold: matchSorter.rankings.CONTAINS }),
              //   filterAll: true,
              //   Filter: ({ filter, onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
              //   Cell: row => (
              //     row.original.unitProduct.product.measurementType !== undefined && measurementTypes.filter(el => el.value === row.original.unitProduct.product.measurementType)[0] ? measurementTypes.filter(el => el.value === row.original.unitProduct.product.measurementType)[0].label : '-'
              //   )

              // },
              // {
              //   Header: "موجودی فرعی",
              //   id: "quantity",
              //   accessor: d => d.quantity,
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   className: "text-center",
              //   sortable: false,
              //   Cell: row => (
              //     row.original.unitProduct.product.subMeasurementType !== undefined
              //       ? <MeasurementTypeDoubleBox
              //         product={row.original.unitProduct.product}
              //         value={row.original.nextQuantity}
              //       />
              //       : 0
              //   )
              // },
              // {
              //   Header: "واحد فرعی",
              //   id: "measurementType",
              //   sortable: false,
              //   accessor: d => d.measurementType,
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   className: "numberFa",
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["measurementType"], threshold: matchSorter.rankings.CONTAINS }),
              //   filterAll: true,
              //   Filter: ({ filter, onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
              //   Cell: row => (
              //     row.original.unitProduct.product.subMeasurementType !== undefined && measurementTypes.filter(el => el.value === row.original.unitProduct.product.subMeasurementType)[0] ? measurementTypes.filter(el => el.value === row.original.unitProduct.product.subMeasurementType)[0].label : '-'
              //   )

              // },
              {
                Header: 'تاریخ ثبت',
                accessor: 'createdAt',
                id: 'createdAt',
                filterable: false,
                width: 170,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['createdAt'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: row =>
                  moment(row.original.createdAt, 'YYYY/M/D H:m').format(
                    'jYYYY/jM/jD ساعت H:mm'
                  )
              },
              // {
              //   Header: "کاربر",
              //   accessor: "fullName",
              //   id: "fullName",
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["fullName"] }),
              //   filterAll: true,
              //   Filter: ({ onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
              //   Cell: (row) => (
              //     row.original.user.fullName
              //   )
              // },
              {
                Header: 'کد سفارش',
                accessor: 'taskCode',
                id: 'taskCode',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                width: 100,
                Cell: row => {
                  return <TaskCode code={row.original.taskCode} />
                }
              },
              {
                Header: 'جزئیات',
                accessor: 'id',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                sortable: false,
                width: 100,
                // Filter: ({ filter, onChange }) =>
                //   <div className="btns-group">
                //     <a onClick={this.handleModalOperation} className="btn btn-primary react-table-add-btn" >
                //       <span>
                //         <FaPlus size="16px" />
                //         افزودن کالای جدید
                //     </span>
                //     </a>
                //     {/* <ImportExcel onChange={(val) => this.importFromExcel(val)} /> */}
                //   </div>
                // ,
                Cell: row => (
                  <div>
                    {/* <a onClick={() => this.handleModalEdit(row.index)} data-index={row.index} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><FiEdit size="24px" /></a> */}
                    <a
                      onClick={() => this.handleDetailsModalShow(row.original)}
                      className="btn btn-sm btn-simple btn-info bmd-ripple bmd-flat-btn delete-btn">
                      <FaInfoCircle size="24px" />
                    </a>
                  </div>
                )
              }
            ]}
            className="-striped -highlight">
            {(state, makeTable, instance) => {
              let recordsInfoText = ''

              const {
                filtered,
                pageRows,
                pageSize,
                sortedData,
                page,
                data
              } = state

              if (sortedData && sortedData.length > 0) {
                let isFiltered = filtered.length > 0

                let totalRecords = sortedData.length

                let totalDataCount = data.length

                let recordsCountFrom = page * pageSize + 1

                let recordsCountTo = recordsCountFrom + pageRows.length - 1

                if (isFiltered)
                  recordsInfoText = `${totalRecords} از ${totalDataCount} نتیجه فیلتر شده`
                else recordsInfoText = `تعداد کل: ${totalRecords}`
              } else recordsInfoText = 'نتیجه ای یافت نشد'

              return (
                <>
                  <div className="row text-right">
                    <div className="col-md-3" style={{ marginBottom: 20 }}>
                      <AsyncWarehouseSelect
                        defaultValue={dto && dto.unitId}
                        onChange={(val, unitType, categoryType) => {
                          this.handleUnitIdChange(val, categoryType)
                        }}
                        className="semantic-select-box"
                      />
                    </div>
                    <div className="col-sm-12">
                      <div className="react-table-top-area">
                        <span className="records-info">{`تعداد کل: ${this.state.totalRecords
                          }`}</span>

                        {/* <ImportExcel onChange={(val) => this.importFromExcel(val)} /> */}

                        <div>
                          <a
                            onClick={() => this.handleShowAll()}
                            className="btn btn-primary pull-left btn-sm"
                            disabled={loading}
                            style={{ margin: 0, marginLeft: 5 }}>
                            <MdPlaylistAddCheck
                              size="20px"
                              style={{ verticalAlign: 'middle' }}
                            />
                            &nbsp;نمایش همه
                          </a>

                          <a
                            onClick={() =>
                              this.setState({
                                modalHeading: 'جستجو',
                                searchModal: true
                              })
                            }
                            className="btn btn-sm btn-primary pull-left"
                            style={{ margin: 0, marginLeft: 5 }}
                            disabled={loading}>
                            <GiMagnifyingGlass
                              size="20px"
                              style={{ verticalAlign: 'middle' }}
                            />
                            &nbsp;جستجو
                          </a>

                          {user && user.userType !== undefined && [0].includes(user.userType) &&
                            <a
                              onClick={() => this.handleModalOperation(1)}
                              className="btn btn-sm btn-primary pull-left"
                              style={{ margin: 0, marginLeft: 5 }}
                              disabled={loading}>
                              <MdRemove
                                size="20px"
                                style={{ verticalAlign: 'middle' }}
                              />
                              &nbsp;عملیات خروج کالاها از انبار
                            </a>
                          }
                          {user && user.userType !== undefined && [0].includes(user.userType) &&
                            <a
                              onClick={() => this.handleModalOperation(0)}
                              className="btn btn-sm btn-primary pull-left"
                              style={{ margin: 0, marginLeft: 5 }}
                              disabled={loading}>
                              <MdAdd
                                size="20px"
                                style={{ verticalAlign: 'middle' }}
                              />
                              &nbsp;عملیات ورود کالاها به انبار
                            </a>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="clearfix" />
                    <br />
                  </div>
                  {makeTable()}
                </>
              )
            }}
          </ReactTable>
        </div>

        <Dialog
          open={searchModal && !loading}
          TransitionComponent={Transition}
          fullWidth={true}
          maxWidth="xs"
          onClose={() => this.setState({ searchModal: false })}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        // style={{ overflow: 'visible' }}
        >
          <DialogTitle>
            <Fab
              color="secondary"
              aria-label="refresh"
              size="small"
              onClick={() => this.setState({ searchModal: false })}
              className="modal-close-btn">
              <MdClose
                size="20px"
                className={loading ? 'mdi-spin mdi-loading' : ''}
              />
            </Fab>
          </DialogTitle>
          <DialogContent className="search-modal">
            {loading && <Loading />}

            <Formik
              enableReinitialize
              initialValues={this.state.dto}
              onSubmit={(values, { setSubmitting }) => {
                // // console.log(values);
                this.handleSearch(values)
                setSubmitting(false)
              }}
            // validationSchema={ValidationSchema}
            >
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                  resetForm
                } = props
                return (
                  <div className="row" style={{ position: 'relative' }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>
                        {/* {JSON.stringify(values)} */}

                        <div className="row">
                          <div className="form-inline search-container">
                            <div className="col-lg-12 col-sm-12">
                              <label>دسته بندی</label>
                              <AsyncCategorySelect
                                clearable
                                categoryType={categoryType}
                                defaultValue={values.categoryId}
                                onChange={val => {
                                  setFieldValue(
                                    'categoryId',
                                    val ? val : undefined
                                  )
                                }}
                                className="semantic-select-box"
                              />
                            </div>

                            <div className="col-lg-12 col-sm-12">
                              <label>برند</label>
                              <AsyncBrandSelect
                                clearable
                                brandType={
                                  categoryType === -1
                                    ? -1
                                    : categoryType === 0
                                      ? 0
                                      : 1
                                }
                                defaultValue={values.brandId}
                                onChange={val => {
                                  setFieldValue(
                                    'brandId',
                                    val ? val : undefined
                                  )
                                }}
                                className="semantic-select-box"
                              />
                            </div>

                            <div className="col-lg-12 col-sm-12">
                              <label>نام کالا</label>

                              <input
                                type="text"
                                onChange={e => {
                                  setFieldValue('name', e.target.value)
                                }}
                                value={values && values.name ? values.name : ''}
                                name="name"
                                className="text-input"
                              />
                            </div>

                            <div className="clearfix form-row" />

                            <div className="col-lg-6 col-sm-12">
                              <label>کد سفارش</label>

                              <DecimalInput
                                type="tel"
                                value={
                                  values && values.taskCode
                                    ? values.taskCode
                                    : undefined
                                }
                                onChange={e => {
                                  setFieldValue('taskCode', e.target.value)
                                }}
                                className="text-input"
                              />
                            </div>

                            <div className="col-lg-6 col-sm-12">
                              <label>تاریخ سفارش</label>

                              <DatePicker
                                onChange={e => {
                                  setFieldValue('date', e)
                                }}
                                value={values && values.date ? values.date : ''}
                                name="date"
                                className="text-input"
                              />
                            </div>

                            <div className="clearfix form-row" />

                            <div className="col-lg-12 col-sm-12">
                              <label>تاریخ ثبت در انبار</label>

                              <DatePicker
                                onChange={e => {
                                  setFieldValue('createdAt', e)
                                }}
                                value={
                                  values && values.createdAt
                                    ? values.createdAt
                                    : ''
                                }
                                name="createdAt"
                                className="text-input"
                              />
                            </div>

                            <div className="clearfix form-row" />

                            {/* <div className="col-lg-4 col-sm-12">
                              <label>کد کالا</label>

                              <input type="text"
                                onChange={e => {
                                  setFieldValue("extraCode", parseInt(e.target.value, 0))
                                }}
                                value={values && values.extraCode ? values.extraCode : ''}
                                name="extraCode"
                                className="text-input"
                              />

                            </div>

                            <div className="clearfix form-row"></div> */}

                            <div className="col-md-12">
                              <button
                                type="submit"
                                className="btn btn-primary btn-block"
                                disabled={isSubmitting}>
                                {loading ? (
                                  <i className="mdi mdi-spin mdi-loading" />
                                ) : (
                                  <i className="mdi mdi-magnify" />
                                )}
                                &nbsp; جستجو &nbsp;
                              </button>
                              {/* <a className="btn btn-primary" 
                    onClick={() => {
                      setFieldValue('travelBrandId', undefined);
                      resetForm({
                        travelBrandId: undefined, transporterId: '', khodroId: '',
                        cityId: '', originTerminalId: '', destinationCityId: '', destinationTerminalId: '', tripClass: '', price: ''
                      })
                      // console.log(values);

                    }}
                  >
                    <i className="mdi mdi-playlist-check"></i>&nbsp;حذف همه فیلترها
                  </a> */}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )
              }}
            </Formik>
          </DialogContent>
        </Dialog>

        <Dialog
          open={this.state.modal}
          onClose={this.handleModalHide}
          TransitionComponent={Transition}
          scroll={'paper'}
          fullScreen={true}
          // maxWidth="lg"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description">
          <DialogTitle>
            <Fab
              color="secondary"
              aria-label="refresh"
              size="small"
              onClick={() => this.handleModalHide()}
              className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
            <span style={{ marginRight: 10 }} />
          </DialogTitle>
          <DialogContent dividers={true}>
            <ProductOperationForm
              id={this.state.model.id}
              categoryType={this.props.categoryType}
              onClose={() => this.handleModalClose()}
              unitProductOperationType={this.state.unitProductOperationType}
            />
          </DialogContent>
        </Dialog>

        <Dialog
          open={this.state.detailsModal}
          onClose={this.handleDetailsModalHide}
          TransitionComponent={Transition}
          scroll={'paper'}
          fullWidth={true}
          maxWidth="lg"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description">
          <DialogTitle>
            <Fab
              color="secondary"
              aria-label="refresh"
              size="small"
              onClick={() => this.handleDetailsModalHide()}
              className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
            <span style={{ marginRight: 10 }} />
          </DialogTitle>
          <DialogContent dividers={true}>
            <ProductOperationDetails
              data={this.state.model}
              onClose={() => this.handleDetailsModalHide()}
            />
          </DialogContent>
        </Dialog>

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={
            'آیا از حذف کالا  [' +
            (this.state.model &&
              this.state.model.product &&
              this.state.model.product.name) +
            '] مطمئن هستید؟'
          }
        />

        {loading ? <Loading /> : ''}
      </div>
    )
  }
}

// export default ProductOperationsList


function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedProductOperationsList = connect(mapStateToProps)(ProductOperationsList);
export { connectedProductOperationsList as ProductOperationsList };